export default __webpack_public_path__ + "1f77739ca9ff2188b539c36f30ffa2be.ttf";